import 'core-js/modules/es.array.concat';
import 'core-js/modules/es.array.filter';
import 'core-js/modules/es.array.includes';
import 'core-js/modules/es.array.join';
import 'core-js/modules/es.array.map';
import 'core-js/modules/es.array.slice';
import 'core-js/modules/es.object.assign';
import 'core-js/modules/es.object.entries';
import 'core-js/modules/es.object.keys';
import 'core-js/modules/es.object.values';
import 'core-js/modules/es.regexp.constructor';
import 'core-js/modules/es.regexp.exec';
import 'core-js/modules/es.regexp.flags';
import 'core-js/modules/es.regexp.to-string';
import 'core-js/modules/es.string.includes';
import 'core-js/modules/es.string.match';
import 'core-js/modules/es.string.replace';
import 'core-js/modules/es.string.split';
import 'core-js/modules/es.string.trim';
import 'core-js/modules/web.dom-collections.for-each';
import { NameFormat } from '@paypalcorp/worldready-name';
import { isWorldReadyInstance } from '@paypalcorp/worldready-core';
import { assertType, assertRange, assert } from 'yaassertion';

function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _createForOfIteratorHelperLoose(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (t) return (t = t.call(r)).next.bind(t);
  if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
    t && (r = t);
    var o = 0;
    return function () {
      return o >= r.length ? {
        done: !0
      } : {
        done: !1,
        value: r[o++]
      };
    };
  }
  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}

var _excluded = ["type", "parts", "value"];
var Cldr = require('cldrjs/dist/cldr');

/**
 * Camelizes strings
 */
function camelize(text) {
  return text.replace(/^([A-Z])|[\s-_]+(\w)/g, function (match, p1, p2) {
    if (p2) return p2.toUpperCase();
    return p1.toLowerCase();
  });
}
function snakeCase(text) {
  return text.replace(/(?:^|\.?)([A-Z0-9])/g, function (x, y) {
    return "_" + y.toLowerCase();
  }).replace(/^_/, "");
}
function camelizeObject(object) {
  return Object.assign.apply(Object, Object.keys(object).map(function (key) {
    var _ref;
    return _ref = {}, _ref[camelize(key)] = object[key], _ref;
  }));
}
function snakeCaseObject(object, specialTransforms) {
  if (specialTransforms === void 0) {
    specialTransforms = {};
  }
  return Object.assign.apply(Object, Object.keys(object).map(function (key) {
    var _ref2;
    return _ref2 = {}, _ref2[specialTransforms[key] || snakeCase(key)] = object[key], _ref2;
  }));
}

/**
 * Utility function to remove literals that are not required.
 * We only want to add a literal if we've previously encountered a non-literal field
 * and it's value is not an empty string. Hence we don't add a literal field to the
 * response immediately as we encounter it, but we wait until we see the next non-literal
 * field before adding the literal to our response.
 * @param {Array} parts an array with details about each part. Required props for each part are:
 *  type: a string specifying whether the part is literal or not
 *  value: value for that part
 * @returns {Array} modified array where unnecessary literals are removed
 */
function removeExtraLiterals(parts) {
  if (parts === void 0) {
    parts = [];
  }
  if (!parts || !parts.length) {
    return;
  }
  var addedFirstNonLiteralField = false,
    literalField = null,
    result = [];
  parts.forEach(function (part) {
    if (part.type !== "literal") {
      if (literalField && addedFirstNonLiteralField && part.value.length) {
        result.push(literalField);
      }
      literalField = null;
      result.push(part);
      if (part.value.length) {
        addedFirstNonLiteralField = true;
      }
    } else {
      literalField = Object.assign({}, part);
    }
  });
  return result;
}
function cloneArray(array) {
  return array.slice(0);
}
function cloneDate(date) {
  return new Date(date.getTime());
}

/**
 * Deeply merges plain objects.
 *
 * Eg.
 * objectDeepAssign( { a: { b: 1, c: 2 } }, { a: { b: 3, d: 4 } }, ... )
 * -> { a: { b: 3, c: 2, d: 4 } }
 *
 * Code from https://github.com/rxaviers/cldrjs/blob/master/src/util/json/merge.js
 */
function objectDeepAssign(destination) {
  for (var _len = arguments.length, sources = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    sources[_key - 1] = arguments[_key];
  }
  sources.forEach(function (source) {
    var prop;
    for (prop in source) {
      if (Array.isArray(source[prop])) {
        // Clone and set arrays.
        destination[prop] = cloneArray(source[prop]);
      } else if (source[prop] instanceof Date) {
        // Clone and set dates.
        destination[prop] = cloneDate(source[prop]);
      } else if (typeof source[prop] === "object") {
        // Merge objects.
        destination[prop] = objectDeepAssign({}, destination[prop], source[prop]);
      } else {
        // Set new values.
        destination[prop] = source[prop];
      }
    }
  });
  return destination;
}

/* Gets value in object path
 * @param {object} obj
 * @param {string|array} path
 * @examples
 * get({foo: 1, bar: {baz: 2}}, 'bar.baz');
 * > 2
 * get({foo: 1, bar: {baz: 2}}, 'foo.bar.baz.quax');
 * > undefined
 * NOTE: Asterisk support for Node.js only (reduced bytes)
 */
var objectGet;
{
  // Client-side
  objectGet = function objectGet(obj, path) {
    if (typeof path === "string") {
      path = path.split(".");
    }
    if (!path.length) {
      return obj;
    }
    if (process.env.NODE_ENV !== "production") {
      if (path.some(function (part) {
        return part === "*";
      })) {
        throw new Error("Internal error: objectGet asterisk support NOT available");
      }
    }
    var prop = path.slice(-1);
    var node = path.slice(0, -1).reduce(function (node, item) {
      return node[item] || {};
    }, obj);
    return node[prop];
  };
}

/**
 * Shallow merges an arary of objects.
 * shallowMerge([{ a: { i: 1 }}, { b: 2}, { a: { x: 99 }}])
 * > { a: { x: 99 }, b: 2 }
 */
function shallowMerge(arrayOfObjects) {
  return Object.assign.apply(Object, [{}].concat(arrayOfObjects));
}
var COMMON_ADDRESS_DATA = "common";
var ADDRESS_TYPES = {
  COARSE: "coarse",
  PORTABLE: "portable"
};
var ADDRESS_STYLES = {
  MULTILINE: "multiline",
  SINGLELINE: "singleline",
  INTERNATIONAL_MULTILINE: "international-multiline",
  INTERNALTIONAL_SINGLELINE: "international-singleline"
};
var ADDRESS_ERROR_CODES = {
  MISSING_ONE_OF: "MISSING_ONE_OF",
  MISSING_REQUIRED: "MISSING_REQUIRED",
  INVALID_PATTERN: "INVALID_PATTERN",
  INVALID_ALL_OFFENSIVE: "INVALID_ALL_OFFENSIVE",
  ADDRESS_CONTAINS_PO_BOX: "ADDRESS_CONTAINS_PO_BOX",
  ADDRESS_CONTAINS_RURAL_ROUTE: "ADDRESS_CONTAINS_RURAL_ROUTE"
};
var COARSE_ADDRESS_FIELDS = ["line1", "line2", "state", "city", "postalCode", "countryCode"];
var PORTABLE_ADDRESS_FIELDS = ["addressLine1", "addressLine2", "addressLine3", "adminArea4", "adminArea3", "adminArea2", "adminArea1", "postalCode", "countryCode"];
var PORTABLE_ADDRESS_WITH_DETAILS_FIELDS = PORTABLE_ADDRESS_FIELDS.concat(["addressDetails.buildingName", "addressDetails.deliveryService", "addressDetails.streetName", "addressDetails.streetNumber", "addressDetails.streetType", "addressDetails.subBuilding"]);
var ADDRESS_TRANSFORM_TYPES = {
  COARSE: "coarse",
  PORTABLE: "portable",
  ADDRESS_PORTABLE_WITH_DETAILS: "address-portable-with-details"
};
var ADDRESS_TYPES_FOR_PO_BOX_RURAL_ROUTE_VALIDATION = {
  SHIPPING: "shipping",
  MAILING: "mailing",
  PRIMARY: "primary"
};

/**
 * TODO: Remove this country specific logic to ignore po box error for US
 * after metrics are gathered from OAS since country specific logic
 * should not be present in sdk.
 */
var COUNTRIES_TO_IGNORE_FOR_PO_BOX_VALIDATION = ["US"];

/**
 * Given a parameter, assert it's a valid address.
 * @param {Object} address the address object
 * @throws TypeError
 */
function assertAddress(address) {
  var props = Object.keys(address);
  if (address.addressDetails) {
    props = props.concat(Object.keys(address.addressDetails).map(function (addressDetailsField) {
      return "addressDetails." + addressDetailsField;
    }));
  }
  props.forEach(function (propName) {
    if (propName === "addressDetails") {
      return;
    }
  });
}
function oldGriffinCoarseSupport(address) {
  var fixes = {};
  if (address.postcode !== undefined && address.postalCode === undefined) {
    fixes.postalCode = address.postcode;
  }
  if (address.country !== undefined && address.countryCode === undefined) {
    fixes.countryCode = address.country;
  }
  // Clone and set coarse address "fixes".
  if (Object.keys(fixes).length) {
    address = objectDeepAssign(address, fixes);
  }
  return address;
}

/**
 * The core transformAddress function
 * @param {Object} address See README for details.
 * @param {Object} options See README for details.
 * @returns See README for details.
 * @example See README for details.
 */
function transformAddress(address, options, metadata) {
  if (options === void 0) {
    options = {};
  }
  assertAddress(address);
  var _options = options,
    from = _options.from,
    to = _options.to;
  if (from === ADDRESS_TRANSFORM_TYPES.COARSE) {
    address = oldGriffinCoarseSupport(address);
  }
  if (from === ADDRESS_TRANSFORM_TYPES.PORTABLE && to === ADDRESS_TRANSFORM_TYPES.COARSE || from === ADDRESS_TRANSFORM_TYPES.COARSE && to === ADDRESS_TRANSFORM_TYPES.PORTABLE) {
    return convertAddress(address, {
      metadata: metadata,
      from: from,
      to: to
    });
  } else if (from === ADDRESS_TRANSFORM_TYPES.ADDRESS_PORTABLE_WITH_DETAILS && to === ADDRESS_TRANSFORM_TYPES.PORTABLE) {
    return convertPortableAddressWithDetailsToPortable(address, {
      metadata: metadata
    });
  } else if (from === ADDRESS_TRANSFORM_TYPES.ADDRESS_PORTABLE_WITH_DETAILS && to === ADDRESS_TRANSFORM_TYPES.COARSE) {
    return convertPortableAddressWithDetailsToCoarse(address, {
      metadata: metadata
    });
  }
  return null;
}

/**
 * Function that converts portable address to coarse and vice versa
 * @param {Object} address - object that needs to be converted to either portable or coarse
 * @param {Object} options - object with following details
 *  metadata: object that has all the details for the countryCode territory
 *  from: string value describing what is the type of input address object (portable | coarse)
 *  to: string value describing what the address object needs to be converted to (portable | coarse)
 * @returns {Object} updated address object
 */
function convertAddress(address, options) {
  if (address === void 0) {
    address = {};
  }
  if (options === void 0) {
    options = {};
  }
  if (!Object.keys(address).length || !options.metadata) {
    return null;
  }
  var transformMapping = metadataTransformMapping(options.metadata, address.countryCode, options.from, options.to);
  var fromAddressFields = options.from === ADDRESS_TRANSFORM_TYPES.PORTABLE ? PORTABLE_ADDRESS_FIELDS : COARSE_ADDRESS_FIELDS;
  var patternsData = objectGet(options.metadata, [address.countryCode, "transform_mapping", "transform_properties", "patterns"]);
  return _transformAddress({
    fromAddress: address,
    fromAddressFields: fromAddressFields,
    patternsData: patternsData,
    transformMapping: transformMapping
  });
}

/**
 * Function that converts high resolution address to portable (low resolution)
 * @param {Object} address - address object that needs to be converted to portable
 * @param {Object} options - object with following details:
 *  metadata: object that has all the details for the countryCode territory
 * @returns {Object}
 */
function convertPortableAddressWithDetailsToPortable(address, options) {
  if (address === void 0) {
    address = {};
  }
  if (options === void 0) {
    options = {};
  }
  if (!Object.keys(address).length || !options.metadata) {
    return null;
  }
  var transformMapping = metadataTransformMapping(options.metadata, address.countryCode, "detailed", ADDRESS_TRANSFORM_TYPES.PORTABLE);
  return portableAddressDetailedToRegular(address, transformMapping);
}

/**
 * Function that converts high resolution address to coarse
 * @param {Object} address - address object that needs to be converted to coarse
 * @param {Object} options - object with following details:
 *  metadata: object that has all the details for the countryCode territory
 * @returns {Object}
 */
function convertPortableAddressWithDetailsToCoarse(address, options) {
  if (address === void 0) {
    address = {};
  }
  if (options === void 0) {
    options = {};
  }
  if (!Object.keys(address).length || !options.metadata) {
    return null;
  }
  var portableAddress = convertPortableAddressWithDetailsToPortable(address, options);
  var coarseAddress = convertAddress(portableAddress, {
    metadata: options.metadata,
    from: ADDRESS_TRANSFORM_TYPES.PORTABLE,
    to: ADDRESS_TRANSFORM_TYPES.COARSE
  });
  return coarseAddress;
}
function metadataTransformMapping(metadata, territory, fromType, toType) {
  return objectGet(metadata, [territory, "transform_mapping", fromType + "_to_" + toType]);
}
function portableAddressDetailedToRegular(address, detailedToPortableTransformMapping) {
  var addressLines = convertDetailedAddressInfoToLines(address, detailedToPortableTransformMapping);
  var transformMappingCopy = Object.assign({}, detailedToPortableTransformMapping);
  delete transformMappingCopy.addressLines;
  var transformedAddress = detailedToPortableTransformMapping ? _transformAddress({
    fromAddress: address,
    fromAddressFields: PORTABLE_ADDRESS_WITH_DETAILS_FIELDS,
    patternsData: {},
    transformMapping: transformMappingCopy
  }) : {};
  // Merge transformed and original: transformed fields take precedence over original fields.
  var merged = PORTABLE_ADDRESS_FIELDS.reduce(function (merged, field) {
    var value = transformedAddress[field] || address[field];
    if (value) {
      merged[field] = value;
    }
    return merged;
  }, {});
  return Object.assign({}, merged, addressLines);
}
function _transformAddress(props) {
  var fromAddress = props.fromAddress;
  var fromAddressFields = props.fromAddressFields;
  var patternsData = props.patternsData;
  var transformMapping = props.transformMapping;
  var patternsRe = {};
  var patternsMatchElement = {};
  var processPatternTransforms = function processPatternTransforms(toField, lineItem) {
    return lineItem.replace(/^patterns\.(.*?)\.\$([0-9])$/, function (garbage, fromField, matchElement) {
      patternsRe[toField] = new RegExp("^" + patternsData[fromField] + "$");
      patternsMatchElement[toField] = +matchElement;
      return fromField;
    });
  };
  return Object.keys(transformMapping).map(function (toField) {
    var line = transformMapping[toField];
    line = line.map(processPatternTransforms.bind(null, toField));
    var parts = toParts(fromAddress, fromAddressFields, line);
    return {
      toField: toField,
      value: collapseParts(parts)
    };
  }).filter(function (pair) {
    return pair.value !== "";
  }).reduce(function (toAddress, pair) {
    var match;
    var toField = pair.toField;
    var value = pair.value;

    // Patterns processing.
    if (patternsRe[toField]) {
      match = value.match(patternsRe[toField]);
      value = match[patternsMatchElement[toField]];
    }
    if (value) {
      toAddress[toField] = value;
    }
    return toAddress;
  }, {});
}

/**
 * Return an address line "parts".
 * @param {Object} address the address object.
 * @param {array} addressFields list of fields of the address (according to its type).
 * @param {array} line metadata layout line
 * @return {array} the line parts populated with values from the address object.
 * [
 *   { type: 'address_line_1', value: '123 Smith Dr.' }
 * ]
 */
function toParts(address, addressFields, line) {
  // loop over fields in this line
  return line.map(function (field) {
    // if the field name from the metadata doesn't match one of the display fields,
    // then it's just a literal separator
    if (addressFields.indexOf(field) === -1) {
      return {
        type: "separator",
        value: field
      };
    }
    return {
      // Note: using `objectGet` due to portable address detailed fields like addressDetails.street_name.
      type: field,
      value: objectGet(address, field.split("."))
    };
  });
}

/**
 * Given a line parts array like this:
 * [
 *   { type: 'admin_area_2', value: 'San Jose' },
 *   { type: 'separator', value: ', ' },
 *   { type: 'admin_area_1', value: 'CA' },
 *   ...
 * ]
 * Collapse it into a string but without any consecutive, initial, or trailing separators
 *
 * @param {array} parts
 * @return {string} the line parts array collapsed into a string
 */
function collapseParts(parts) {
  return parts.filter(function (part) {
    // filter any blank values
    return part.value;
  }).filter(function (part, index, array) {
    // filter any consecutive separators
    // skip non-separators
    if (part.type !== "separator") {
      return true;
    }
    // filter a separator if the next part is going to be a separator
    if (array[index + 1] && array[index + 1].type === "separator") {
      return false;
    }
    return true;
  }).filter(function (part, index, array) {
    // filter any initial or final separator
    // skip non-separators
    if (part.type !== "separator") {
      return true;
    }

    // filter any line-initial or line-final separators
    if (index === 0 || index === array.length - 1) {
      return false;
    }
    return true;
  }).reduce(function (lineString, part) {
    // combine all 'value' properties into a single string
    return lineString += part.value;
  }, "");
}

/**
 * Helper function to convert addressDetails part of the address object to an object
 * with addressLines properties.
 * @param {Object} addressData - object containing address data
 * @param {Object} addressMapping - object containing which fields of address details maps to which address lines
 * @returns {Object}
 */
function convertDetailedAddressInfoToLines(addressData, transformMapping) {
  if (addressData === void 0) {
    addressData = {};
  }
  if (transformMapping === void 0) {
    transformMapping = {};
  }
  if (!addressData.addressDetails || !transformMapping.addressLines) {
    return null;
  }
  var addressLines = transformMapping["addressLines"].map(function (addressLine) {
    var parts = toParts(addressData, PORTABLE_ADDRESS_WITH_DETAILS_FIELDS, addressLine);
    return collapseParts(parts);
  }).filter(function (value) {
    return value !== "";
  });

  /**
   * When we are converting from high resolution to low resolution address and address line array is ["", "sample address line 2", ""],
   * then AddressConvert api will return addressLine1 as sample address line 2. But when we call AddressFormat.formatToParts(),
   * then addressLine1 will still be "" (empty) and addressLine2 will be sample address line 2.
   */

  return addressLines.reduce(function (object, item, index) {
    object["addressLine" + (index + 1)] = item;
    return object;
  }, {});
}

/**
 * Actual PersonNameFormat implementation. The idea is the this whole file
 * becomes open source.
 */
var ADDRESS_LINES = ["addressLine1", "addressLine2", "addressLine3"];
var elements = {
  portable: ADDRESS_LINES.concat(["adminArea4", "adminArea3", "adminArea2", "adminArea1", "postalCode", "countryCode", "addressDetails.buildingName", "addressDetails.deliveryService", "addressDetails.streetName", "addressDetails.streetNumber", "addressDetails.streetType", "addressDetails.subBuilding"]),
  coarse: ["line1", "line2", "state", "city", "postalCode", "postcode", "countryCode", "country"]
};
function joinPartsValues(parts) {
  return parts.map(function (_ref3) {
    var value = _ref3.value;
    return value;
  }).join("");
}
var unsupportedCountryCodeRe = /Unsupported value for address.country_code/;
function transformAddress$1(address, options, addressMetadata) {
  try {
    return transformAddress(address, options, addressMetadata);
  } catch (error) {
    if (unsupportedCountryCodeRe.test(error.message)) {
      throw new Error("You have not loaded metadata for " + error.attributes.countryCode + " country");
    }
    throw error;
  }
}

/**
 * Given:
 * - stringLayout: "{foo} {bar}"
 * - stringLayouts:
 *   {
 *     "bar": "{a} {b.c}"
 *   }
 * Returns:
 * [
 *   {
 *     "type": "foo"
 *   },
 *   {
 *     "type": "literal",
 *     "value": " "
 *   },
 *   {
 *     "type": "bar",
 *     "parts": [
 *       {
 *         "type": "a"
 *       },
 *       {
 *         "type": "literal",
 *         "value": " "
 *       },
 *       {
 *         "type": "b.c"
 *       }
 *     ]
 *   }
 * ]
 */
// TODO: Find a better place for common functions between address and name
function stringLayoutToPartsLayout(stringLayout, stringLayouts, checkStringLayouts) {
  if (stringLayouts === void 0) {
    stringLayouts = {};
  }
  if (checkStringLayouts === void 0) {
    checkStringLayouts = true;
  }
  var partsLayout = [];
  var lastMatchPos = 0;

  // For every matching variable (e.g., "{foo}"), add two parts: the literal
  // that precedes it and the matching type variable (e.g., { type: "foo" }).
  stringLayout.replace(/{[^}]+}/g, function (match, pos) {
    partsLayout.push({
      type: "literal",
      value: stringLayout.slice(lastMatchPos, pos)
    });
    var type = match.slice(1, -1);
    var part = {
      type: type
    };
    if (checkStringLayouts && stringLayouts[type]) {
      part.parts = stringLayoutToPartsLayout(stringLayouts[type], stringLayouts, false);
    }
    partsLayout.push(part);
    lastMatchPos = pos + match.length;
  });
  partsLayout.push({
    type: "literal",
    value: stringLayout.slice(lastMatchPos)
  });

  // Remove empty literals.
  return partsLayout.filter(function (_ref4) {
    var type = _ref4.type,
      value = _ref4.value;
    return type !== "literal" || value;
  });
}
var DEFAULT_SCRIPT_FALLBACK = "Latn";
/**
 * Returns the object script, which is:
 * - `undefined` if the string is empty,
 * - `"Latin"` if the whole string is Latin, or
 * - The regionDefaultScript if string contains any non-Latin (because it's easier to do this than to
 *   identify which script it really is AND it's assertive in our case).
 */
function getStringScript(string, regionDefaultScript) {
  if (!string.length) {
    return;
  }
  for (var _iterator = _createForOfIteratorHelperLoose(string), _step; !(_step = _iterator()).done;) {
    var ch = _step.value;
    if (ch.charCodeAt(0) > 0x24f) {
      return regionDefaultScript;
    }
  }
  return "Latn";
}

/**
 * Helper function that determines what script should be used to format the address and name.
 * Determination rules and fallbacks are as follows:
 *  1. For address region with region default script as non Latn script and if address/name object contain non Latn script characters, then use non Latn script if supported by address region.
 *  2. If address object scipt is not supported for addressRegion or we don't have the metadata for that script,
 *      then fallback to the primary_script for addressRegion identified in G11nMetadata
 *  3. if for some reason we don't have address layout metadata for the primary_script identified in G11nMetadata for primary_script,
 *      then fallback to 'Latn' as we always have address layout for Latn script
 * @param {Object} stringLayouts an object containing layouts for all the scripts for addressRegion
 * @param {Object} options object with additional properties for identifying the final script that should be used
 * @returns {Object} an object with the address layout based on script identified by above rules
 */
var getLayoutFromScript = function getLayoutFromScript(stringLayouts, options) {
  if (stringLayouts === void 0) {
    stringLayouts = {};
  }
  if (options === void 0) {
    options = {};
  }
  if (!Object.keys(stringLayouts).length || !options.primaryScript) {
    return null;
  }
  var _options2 = options,
    finalScript = _options2.finalScript,
    primaryScript = _options2.primaryScript;
  return stringLayouts[finalScript] || stringLayouts[primaryScript] || stringLayouts[DEFAULT_SCRIPT_FALLBACK];
};

/**
 * Actual formatToParts function.
 *
 * @param {String} address A portable or coarse address.
 * @param {String} options.allowedValues Object of address elements and their allowed values array key-value pairs
 * @param {String} options.regionDefaultScript Region default script
 * @param {String} options.localeScript Locale script
 * @param {Object} options.stringLayouts Metadata for the chosen style, e.g.:
 *   {
 *     "addressLine1": "{addressDetails.streetType} {addressDetails.streetName}, {addressDetails.streetNumber}",
 *     "addressLine2": "{addressDetails.subBuilding}",
 *     "Latn": "{addressLine1}\n{addressLine2}\n{addressLine3}\n{adminArea2} {adminArea1}\n{countryCode}"
 *   }
 *   TODO Should we process stringLayouts at constructor level and pass partsLayout here instead?
 * @param {Object} options.supportedScripts Supported scripts array.
 * @param {Object} options.transforms Transform functions, e.g.:
 *   {
 *     "adminArea1": "uppercase"
 *   }
 *   TODO Should we process transformations at constructor level and pass the below here instead?
 *   {
 *     "adminArea1": value => value.toUpperCase()
 *   }
 * @param {String} options.type Address type (portable or coarse)
 * @param {Object} requiredValues Object of address elements and their required values array key-value pairs
 * @param {Object} hiddenValues Object of address elements and their hidden values array key-value pairs
 *
 * @return {Array} Formatted address parts.
 */
function addressFormatToParts(address, _ref5, nameParts, _ref6) {
  var _this = this;
  var recipient = _ref5.recipient,
    businessName = _ref5.businessName;
  var _ref6$allowedValues = _ref6.allowedValues,
    allowedValues = _ref6$allowedValues === void 0 ? {} : _ref6$allowedValues,
    internationalRegionName = _ref6.internationalRegionName,
    regionDefaultScript = _ref6.regionDefaultScript,
    localeScript = _ref6.localeScript,
    stringLayouts = _ref6.stringLayouts,
    supportedScripts = _ref6.supportedScripts,
    transforms = _ref6.transforms,
    type = _ref6.type,
    _ref6$requiredValues = _ref6.requiredValues,
    requiredValues = _ref6$requiredValues === void 0 ? {} : _ref6$requiredValues,
    _ref6$hiddenValues = _ref6.hiddenValues,
    hiddenValues = _ref6$hiddenValues === void 0 ? {} : _ref6$hiddenValues,
    _ref6$disabledValues = _ref6.disabledValues,
    disabledValues = _ref6$disabledValues === void 0 ? {} : _ref6$disabledValues,
    _ref6$presetValue = _ref6.presetValue,
    presetValue = _ref6$presetValue === void 0 ? {} : _ref6$presetValue,
    language = _ref6.language;
  var addressCopy = Object.assign({}, address);
  if (type === "coarse") {
    addressCopy = oldGriffinCoarseSupport$1(addressCopy);
  }
  var addressScript;

  // Optimization:
  // If the region default script is different than "Latn", check address.
  // Otherwise, not needed, it's always going to be "Latn".
  if (regionDefaultScript === "Latn") {
    addressScript = "Latn";
  } else {
    addressScript = getStringScript(Object.entries(addressCopy).filter(function (_ref7) {
      var elementType = _ref7[0];
      return isProperty[type][elementType];
    }).map(function (_ref8) {
      var value = _ref8[1];
      return value;
    }).join(""), regionDefaultScript);
  }

  /**
   * finalScript is determined in following preference order:
   * 1. address script : if address object is not empty then use address script
   * 2. locale script : if address is empty then fallback to locale script
   * 3. region default script: if locale script is not supported then fallback to region's default script
   * 4. Latn : if region default script is unavailable then fallback to Latn
   * For example:
   * 1. in ja-JP locale script is JPAN and address object is empty then state value should be in JPAN
   * 2. in en-JP locale script is LATN and address object is empty then state value should be in LATN
   * 3. in ar-EG locale script is ARAB and for GR ARAB is not supported script so it will fallback to LATN (region's default script)
   */
  var finalScript = addressScript || (supportedScripts.includes(localeScript) ? localeScript : regionDefaultScript || "Latn");
  if (internationalRegionName) {
    addressCopy.countryCode = internationalRegionName;
  }
  if (businessName) {
    addressCopy.businessName = businessName;
  }
  if (transforms) {
    Object.entries(transforms).filter(function (_ref9) {
      var element = _ref9[0];
      return addressCopy[element];
    }).forEach(function (_ref10) {
      var element = _ref10[0],
        transformList = _ref10[1];
      return transformList.forEach(function (transform) {
        addressCopy[element] = transformFns[transform](addressCopy[element]);
      });
    });
  }

  // The address script determines the layout (e.g., latin vs Japanese), but the
  // user region determines the supported scripts (e.g., on US only latin
  // addresses are supported, on JP both latin and Japanese are supported).
  var stringLayout = getLayoutFromScript(stringLayouts, {
    primaryScript: regionDefaultScript,
    finalScript: finalScript
  });

  // For some regions for example "CA", "CH", "ID"
  // It is possible to have localized state list in different language where the script is Latn only.
  // e.g. stateList in en-ID and id-ID are in two language, but the script is Latn only.
  // So, we need to check if a particular language entry is existed or not, if not fall back to `default`.
  allowedValues = allowedValues[finalScript] ? allowedValues[finalScript][language] || allowedValues[finalScript]["default"] || {} : {};

  // Override string presetValue
  Object.keys(presetValue).forEach(function (property) {
    if (typeof presetValue[property] == "string" && property !== "countryCode") {
      addressCopy[property] = presetValue[property];
    }
  });
  var partsLayout = stringLayout.split("\n").map(function (stringLayout) {
    var parts = stringLayoutToPartsLayout(stringLayout, stringLayouts);
    if (!internationalRegionName) {
      parts = parts.filter(function (_ref11) {
        var type = _ref11.type;
        return type !== "countryCode";
      });
    }
    fillParts(parts, allowedValues, requiredValues, hiddenValues, disabledValues);
    parts = filterDisabledParts(parts);
    return {
      type: "line",
      parts: parts
    };
  }).filter(function (_ref12) {
    var parts = _ref12.parts;
    return parts.length;
  });

  // TODO Transform (at constructor-time) partsLayout to include recipient
  // localized layout. Then we don't need this extra block and everything
  // happens naturally in fill() above.
  if (recipient) {
    partsLayout.forEach(function (parentPart) {
      var _parentPart$parts = parentPart.parts,
        parts = _parentPart$parts === void 0 ? [] : _parentPart$parts;
      parts.forEach(function (part) {
        if (part.type === "recipient") {
          var _parts = _this.personNameFormatterSingleton().formatToParts(recipient);
          part.parts = _parts;
          part.value = joinPartsValues(_parts);
        }
        return part;
      });
    });
  }
  return fill(partsLayout, addressCopy);
}
function filterDisabledParts(parts) {
  if (parts) {
    parts = parts.filter(function (_ref13) {
      var disabled = _ref13.disabled;
      return !disabled;
    });
    parts.forEach(function (part) {
      if (part && part.parts) {
        part.parts = filterDisabledParts(part.parts);
      }
    });
  }
  return parts;
}
function fillParts(parts, allowedValues, requiredValues, hiddenValues, disabledValues) {
  if (allowedValues === void 0) {
    allowedValues = {};
  }
  if (requiredValues === void 0) {
    requiredValues = {};
  }
  if (hiddenValues === void 0) {
    hiddenValues = {};
  }
  if (disabledValues === void 0) {
    disabledValues = {};
  }
  if (parts) {
    parts.filter(function (_ref14) {
      var type = _ref14.type;
      return type in allowedValues;
    }).forEach(function (part) {
      return part.allowedValues = allowedValues[part.type];
    });
    // setting `required` property only when it is set to true
    parts.filter(function (_ref15) {
      var type = _ref15.type;
      return type in requiredValues && requiredValues[type];
    }).forEach(function (part) {
      return part.required = true;
    });
    // setting `hidden` property
    parts.filter(function (_ref16) {
      var type = _ref16.type;
      return type in hiddenValues && hiddenValues[type];
    }).forEach(function (part) {
      return part.hidden = true;
    });
    parts.filter(function (_ref17) {
      var parts = _ref17.parts;
      return parts;
    }).forEach(function (part) {
      return fillParts(part.parts, allowedValues, requiredValues, hiddenValues, disabledValues);
    });
    // setting `disabled` property
    parts.filter(function (_ref18) {
      var type = _ref18.type;
      return type in disabledValues && disabledValues[type];
    }).forEach(function (part) {
      return part.disabled = true;
    });
    parts.filter(function (_ref19) {
      var parts = _ref19.parts;
      return parts;
    }).forEach(function (part) {
      return fillParts(part.parts, allowedValues, requiredValues, hiddenValues, disabledValues);
    });
  }
  return parts;
}

/**
 * Returns a coarse address (using postalCode and countryCode) when given an
 * old (actually griffin-node) coarse address (using postcode and country).
 * Note: modifies passed address (not a problem since we pass a clone).
 */
function oldGriffinCoarseSupport$1(address) {
  var postcode = address.postcode,
    country = address.country;
  return Object.assign(address, postcode && {
    postalCode: postcode
  }, country && {
    countryCode: country
  });
}

/**
 * Given:
 * - partsLayout:
 *   [
 *     {
 *       "type": "foo"
 *     },
 *     {
 *       "type": "literal",
 *       "value": " "
 *     },
 *     {
 *       "type": "bar",
 *       "parts": [
 *         {
 *           "type": "a"
 *         },
 *         {
 *           "type": "literal",
 *           "value": " "
 *         },
 *         {
 *           "type": "b.c"
 *         }
 *       ]
 *     }
 *   ]
 * - object:
 *   {
 *     "foo": "Foo",
 *     "a": "Aaa",
 *     "b": {
 *       "c": "Bbb"
 *     }
 *   }
 * Returns:
 * [
 *   {
 *     "type": "foo",
 *     "value": "Foo"
 *   },
 *   {
 *     "type": "literal",
 *     "value": " "
 *   },
 *   {
 *     "type": "bar",
 *     "value": "Aaa Bbb",
 *     "parts": [
 *       {
 *         "type": "a",
 *         "value": "Aaa"
 *       },
 *       {
 *         "type": "literal",
 *         "value": " "
 *       },
 *       {
 *         "type": "b.c",
 *         "value": "Bbb"
 *       }
 *     ]
 *   }
 * ]
 */
function fill(partsLayout, object) {
  var result = partsLayout.map(function (_ref20) {
    var type = _ref20.type,
      parts = _ref20.parts,
      value = _ref20.value,
      etc = _objectWithoutPropertiesLoose(_ref20, _excluded);
    if (type !== "literal") {
      if (parts) {
        parts = fill(parts, object);
        value = joinPartsValues(parts);
      }
      if (!value) {
        value = objectGet(object, type) || "";
      }
    }
    return Object.assign(Object.assign({
      type: type,
      value: value
    }, etc), parts && {
      parts: parts
    });
  });
  result = removeExtraLiterals(result);
  return result;
}

/**
 * isProperty is a hash of the form: { <element>: true }, which makes easier to
 * check if a string is one of the elements listed above.
 */
var isProperty = shallowMerge(Object.entries(elements).map(function (_ref21) {
  var _ref23;
  var type = _ref21[0],
    elements = _ref21[1];
  return _ref23 = {}, _ref23[type] = shallowMerge(elements.map(function (field) {
    var _ref22;
    return _ref22 = {}, _ref22[field] = true, _ref22;
  })), _ref23;
}));
var transformFns = {
  uppercase: function uppercase(value) {
    return value.toUpperCase();
  }
};

/**
 * Given an object with properties and an array of valid string property names,
 * Clone the object and:
 * 1) Remove invalid properties,
 * 2) Remove non-string properties,
 * 3) Remove properties with only whitespace,
 * 4) Trim remaining string properties
 *
 * @param {Object} object the object to trim
 * @param {array} properties array of properties to preserve
 *
 * @return {Object} the cloned & trimmed object
 */
function trimObject(object, properties) {
  var clonedObject = {};
  properties.forEach(function (property) {
    var value = object[property];
    if (value === undefined) {
      return;
    }
    if (typeof value === "string") {
      value = value.trim();
    }
    clonedObject[property] = value;
  });
  return clonedObject;
}
var ENVIRONMENT = {
  PRODUCTION: "production"
};

/**
 * The core validateAddress function
 * @param {Object} address See README for details.
 * @param {Object} type See README for details.
 * @returns See README for details.
 * @example See README for details.
 */
function validateAddress(address, type, properties, options) {
  var _retErrors;
  // address
  assertAddress(address);
  var retErrors = [];
  Object.defineProperty(retErrors, "errors", {
    get: function get() {
      if (process.env.NODE_ENV !== ENVIRONMENT.PRODUCTION) {
        var errorMsg = "Please note that errors are no longer returned as an object, instead they are returned as an array. " + "From now on, please access the array directly rather than through the errors property. For more information, please read here: " + "https://github.paypal.com/pages/Globalization-R/worldready-js/docs/address-api.html#addressformatprototypevalidateaddressobj";
        console.warn(errorMsg);
      }
      return this;
    }
  });
  var fields = type === ADDRESS_TYPES.PORTABLE ? PORTABLE_ADDRESS_WITH_DETAILS_FIELDS : COARSE_ADDRESS_FIELDS;
  if (type === ADDRESS_TYPES.COARSE) {
    address = oldGriffinCoarseSupport(address);
  }
  address = trimAddress(address, type);

  // Get errors from _validateAddress and push them
  (_retErrors = retErrors).push.apply(_retErrors, _validateAddress(address, fields, properties, Object.assign({}, options, {
    type: type
  })));
  if (type === ADDRESS_TYPES.PORTABLE) {
    // If non address lines error exist then return errors.
    var nonAddressLineError = retErrors.filter(function (error) {
      return !error.element.includes("addressLine") && !error.element.includes("Details");
    });
    if (nonAddressLineError.length) {
      return retErrors;
    }
    var addressLineErrors = retErrors.filter(function (error) {
      return error.element.includes("addressLine");
    });

    // If there are any errors that are identified for non-required fields (non-field level checks),
    // then we want to return those errors directly.
    var errors = retErrors.filter(function (error) {
      return error.code !== ADDRESS_ERROR_CODES.MISSING_ONE_OF && error.code !== ADDRESS_ERROR_CODES.MISSING_REQUIRED;
    });
    if (errors && errors.length) {
      return retErrors;
    }
    var highResProperties = Object.keys(properties.required).filter(function (field) {
      return field.includes("addressDetails");
    });
    // if addressLine (low res) error exist and high resolution properties
    // are not in required properties then return error.
    if (highResProperties.length === 0 && addressLineErrors.length !== 0) {
      return retErrors;
    }
    var detailErrors = retErrors.filter(function (error) {
      return error.element.includes("Details");
    });
    // if detailErrors or addressLineErrors length is zero, this means
    // either address is valid high or low resolution address.
    if (detailErrors.length === 0 || addressLineErrors.length === 0) {
      retErrors = [];
    }
  }
  return retErrors;
}
function _validateAddress(address, fields, properties, options) {
  if (options === void 0) {
    options = {};
  }
  var isRequiredAlgebraValidResult = isRequiredAlgebraValid(address, getRequiredAlgebra(properties));
  return fields.reduce(function (errors, field) {
    return errors.concat(validateField(address, field, properties, Object.assign({}, options, {
      isRequiredAlgebraValidResult: isRequiredAlgebraValidResult
    })));
  }, []);
}
function getRequiredAlgebra(properties) {
  return typeof properties.requiredAlgebra === "string" ? properties.requiredAlgebra : null;
}
function trimAddress(address, type) {
  // pare down to only relevant fields and trim string fields themselves
  // remove full_name and business_name because those values are passed in via options.name and options.organization
  var addressEntryFields = type === ADDRESS_TYPES.PORTABLE ? PORTABLE_ADDRESS_FIELDS.concat("addressDetails") : COARSE_ADDRESS_FIELDS;
  return trimObject(address, addressEntryFields);
}
function isRequiredAlgebraValid(address, requiredAlgebra) {
  if (!requiredAlgebra) {
    return false;
  }
  return requiredAlgebra.split("||").some(function (group) {
    return group.split("&&").every(function (field) {
      return objectGet(address, field.trim());
    });
  });
}
/**
 * Validates a specific field (`field` parameter, e.g. 'address_line_1') of the passed `address` object
 * based on the metadata `properties`.
 */
function validateField(address, field, properties, options) {
  if (options === void 0) {
    options = {};
  }
  var _options3 = options,
    type = _options3.type,
    isRequiredAlgebraValidResult = _options3.isRequiredAlgebraValidResult;
  var requiredAlgebra = getRequiredAlgebra(properties);
  var required = properties.required ? properties.required[field] : null;
  var validationRegex = properties.validationRegex ? properties.validationRegex[field] : null;
  var offensiveWordRegex = getOffensiveWordRegex(properties, {
    field: field,
    type: type
  });
  var validListRegex = getValidListRegex(properties, {
    field: field,
    type: type
  });
  var applyRequiredAlgebra = requiredAlgebra && requiredAlgebra.includes(field) ? true : false;
  var errors = [];
  var fieldValue = objectGet(address, field.split("."));

  // Check for offensive word pattern, po box & rural route in an address field
  // NOTE: This check should be performed on non-required fields as well
  if (field && fieldValue) {
    if (!isAddressFieldInValidList(fieldValue, validListRegex)) {
      var offensiveWordError = validateAddressFieldForOffensiveTerms(field, fieldValue, offensiveWordRegex);
      if (offensiveWordError && offensiveWordError.length) {
        errors.push.apply(errors, offensiveWordError);
      }
      if (!COUNTRIES_TO_IGNORE_FOR_PO_BOX_VALIDATION.includes(address.countryCode)) {
        var poBoxErrors = performPoBoxValidation(field, fieldValue, Object.assign({}, options, {
          type: type,
          addressValidations: properties.addressValidations
        }));
        if (poBoxErrors && poBoxErrors.length) {
          errors.push.apply(errors, poBoxErrors);
        }
      }
      var ruralRouteErrors = performRuralRouteValidation(field, fieldValue, Object.assign({}, options, {
        addressValidations: properties.addressValidations
      }));
      if (ruralRouteErrors && ruralRouteErrors.length) {
        errors.push.apply(errors, ruralRouteErrors);
      }
    }
  }
  if (!required && !validationRegex && !applyRequiredAlgebra) {
    return errors;
  }
  if (applyRequiredAlgebra && !isRequiredAlgebraValidResult) {
    errors.push({
      code: ADDRESS_ERROR_CODES.MISSING_ONE_OF,
      element: field,
      requiredAlgebra: requiredAlgebra
    });
  }
  // Check for missing required address properties.
  if (!applyRequiredAlgebra && required && !fieldValue) {
    errors.push({
      code: ADDRESS_ERROR_CODES.MISSING_REQUIRED,
      element: field
    });
  }

  // Check for invalid postal code.
  if (field === "postalCode" && validationRegex) {
    // TODO Create the regular expression instance once elsewhere, not in here everytime.
    var re = new RegExp("^" + validationRegex + "$");
    if (fieldValue && !re.test(fieldValue)) {
      errors.push({
        code: ADDRESS_ERROR_CODES.INVALID_PATTERN,
        element: field
      });
    }
  }
  return errors;
}

/**
 * Utility function to perform po box validation
 * @param {String} field address field (addressLine1, addressLine2, etc.)
 * @param {String} value value of the address field
 * @param {Object} options an object which contains following props
 *  - type: coarseAddressData | portableAddressData
 *  - addressType: shipping | mailing | primary
 *  - addressValidations: an object that contains regex pattern to be used for validation
 *  - addressRegion: two letter address region code (US, GB, etc.)
 * @returns {Array} returns an array with error code if the address field value contains po box
 */
function performPoBoxValidation(field, value, options) {
  var type = options.type,
    addressType = options.addressType,
    addressValidations = options.addressValidations,
    addressRegion = options.addressRegion;
  var poBoxValidations = addressValidations.default.poBox.territory[addressRegion];
  if (!poBoxValidations) {
    return [];
  }
  var addressTypesForPoBoxValidation = poBoxValidations.address_type;
  var regexInfo = getPoBoxRegex(poBoxValidations, field, type);
  if (regexInfo && regexInfo.pattern && regexInfo.flags) {
    var regex = new RegExp(regexInfo.pattern, regexInfo.flags);
    if (addressTypesForPoBoxValidation.includes(addressType) && regex.test(value)) {
      return [{
        code: ADDRESS_ERROR_CODES.ADDRESS_CONTAINS_PO_BOX,
        element: field
      }];
    }
  }
  return [];
}
function getPoBoxRegex(source, field, type) {
  if (!source || !type || !field) {
    return null;
  }
  var result = source.layout_type[type] || source.layout_type.default;
  result = result.properties[field] || result.properties.default;
  return result;
}

/**
 * Utility function to perform rural route validations
 * @param {String} field address field (addressLine1, addressLine2, etc.)
 * @param {String} value value of the address field
 * @param {Object} options an object which contains following props
 *  - addressType: shipping | mailing | primary
 *  - addressValidations: an object that contains regex pattern to be used for validation
 *  - addressRegion: two letter address region code (US, GB, etc.)
 *  - addressData: portableAddressData | coarseAddressData
 * @returns {Array} returns an array with error code if the address field value contains rural route
 */
function performRuralRouteValidation(field, fieldValue, options) {
  var addressType = options.addressType,
    addressValidations = options.addressValidations,
    addressRegion = options.addressRegion,
    addressData = options.addressData,
    ruralRouteValidations = addressValidations[addressData].ruralRoute[addressRegion];
  if (!ruralRouteValidations || !Object.keys(ruralRouteValidations).length) {
    return [];
  }
  var addressTypesForRuralRouteValidation = ruralRouteValidations.address_type,
    regexInfo = getRuralRouteRegex(ruralRouteValidations, field);
  if (regexInfo && regexInfo.pattern && regexInfo.flags) {
    var regex = new RegExp(regexInfo.pattern, regexInfo.flags);
    if (addressTypesForRuralRouteValidation.includes(addressType) && regex.test(fieldValue)) {
      return [{
        code: ADDRESS_ERROR_CODES.ADDRESS_CONTAINS_RURAL_ROUTE,
        element: field
      }];
    }
  }
  return [];
}
function getRuralRouteRegex(source, field) {
  if (!source || !field) {
    return;
  }
  return source.properties[field] || source.properties.default;
}
function getOffensiveWordRegex(properties, options) {
  if (options === void 0) {
    options = {};
  }
  if (!properties || !options.field) {
    return null;
  }
  var _options4 = options,
    field = _options4.field,
    type = _options4.type;
  var result = properties.addressValidations[type] || properties.addressValidations.default;
  result = result.offensive.pattern[field] || result.offensive.pattern.default || null;
  return result;
}
function getValidListRegex(properties, options) {
  if (options === void 0) {
    options = {};
  }
  if (!properties || !options.field) {
    return null;
  }
  var _options5 = options,
    field = _options5.field,
    type = _options5.type;
  var result = properties.addressValidations[type] || properties.addressValidations.default;
  result = result.validList[field] || result.validList.default || null;
  return result;
}
function isAddressFieldInValidList(fieldValue, validListRegex) {
  if (fieldValue === void 0) {
    fieldValue = "";
  }
  if (validListRegex === void 0) {
    validListRegex = "";
  }
  if (fieldValue === "" || validListRegex === "") {
    return false;
  }
  validListRegex = new RegExp("^(" + validListRegex + ")$", "i");
  if (validListRegex.test(fieldValue.toLowerCase())) {
    return true;
  }
  return false;
}
function validateAddressFieldForOffensiveTerms(field, fieldValue, offensiveWordRegex) {
  if (field === void 0) {
    field = "";
  }
  if (fieldValue === void 0) {
    fieldValue = "";
  }
  if (field === "" || fieldValue === "" || !offensiveWordRegex || offensiveWordRegex === "") {
    return null;
  }
  var regex = new RegExp("\\b" + offensiveWordRegex + "+\\b", "i");
  if (fieldValue && regex.test(fieldValue)) {
    return [{
      code: ADDRESS_ERROR_CODES.INVALID_ALL_OFFENSIVE,
      element: field
    }];
  }
  return null;
}
var getMissingMetadataError = function getMissingMetadataError(path) {
  var message = "Missing WorldReady metadata, please refer to https://github.paypal.com/pages/Globalization-R/worldready-js/docs/about-load-worldready-data.html";
  if (path) {
    message += "\nPath: " + path;
  }
  return new Error(message);
};
function validateCldr(path, value, options) {
  if (options === void 0) {
    options = {
      skip: []
    };
  }
  var skipBoolean = options.skip.some(function (regex) {
    return regex.test(path);
  });
  if (skipBoolean) {
    return;
  }
  if (value === undefined) {
    throw getMissingMetadataError(path);
  }
}
var countryAliasMapping = {
  C2: "CN",
  UK: "GB"
};
function getResolvedRegion(region) {
  return countryAliasMapping[region] || region;
}
var assertAddress$1, addressFormatToPartsAsserts;
function validateRequiredCldr(path, value) {
  validateCldr(path, value, {
    skip: [/supplemental\/[A-Za-z]*\/[A-Z]{2}\/maxLength/, /supplemental\/[A-Za-z]*\/[A-Z]{2}\/validationRegex/, /supplemental\/[A-Za-z]*\/[A-Z]{2}\/requiredAlgebra/]
  });
}
var AddressFormat = /*#__PURE__*/function () {
  function AddressFormat(worldReady, options) {
    var _this2 = this;
    if (process.env.NODE_ENV !== ENVIRONMENT.PRODUCTION) {
      assertType(worldReady, "worldReady", ["object", "plain object"]);
      if (!isWorldReadyInstance(worldReady)) {
        throw new Error("DEPRECATED WARNING: AddressFormat API has changed for consistency with other formatters, see our updated docs for more information.\nFix your code by using:\n" + ("new AddressFormat(new WorldReady(\"" + worldReady.language + "-" + worldReady.region + "\"), " + JSON.stringify(Object.assign({
          addressRegion: worldReady.region
        }, options || {})) + ")"));
      }
      assertType(options, "options", ["undefined", "plain object"]);
    }
    options = options || {};
    var cldr = worldReady.globalize.cldr;
    if (process.env.NODE_ENV !== ENVIRONMENT.PRODUCTION) {
      assertType(options.addressRegion, "options.addressRegion", ["string"]);
      this._debug_options = options;
    }

    // used to return localized state and city name and select address layout
    var localeScript = cldr.attributes.script;
    var addressRegion = getResolvedRegion(options.addressRegion);
    var _options6 = options,
      _options6$type = _options6.type,
      type = _options6$type === void 0 ? ADDRESS_TYPES.PORTABLE : _options6$type,
      _options6$style = _options6.style,
      style = _options6$style === void 0 ? ADDRESS_STYLES.MULTILINE : _options6$style;

    // Error Checks: properties
    if (process.env.NODE_ENV !== ENVIRONMENT.PRODUCTION) {
      // Check options.type
      var availableTypes = Object.values(ADDRESS_TYPES);
      assertType(type, "options.type", ["string"]);
      assertRange(type, availableTypes, "Invalid options.type {{value}}, expected one of {{availableTypes}}.", {
        value: type,
        availableTypes: availableTypes
      });
      // Check options.style
      var availableStyles = Object.values(ADDRESS_STYLES);
      assertType(style, "options.style", ["string"]);
      assertRange(style, availableStyles, "Invalid options.style {{value}}, expected one of {{availableStyles}}.", {
        value: style,
        availableStyles: availableStyles
      });
    }
    this.type = type;
    this.addressRegion = addressRegion;
    var addressData = type + "AddressData";
    cldr.on("get", validateRequiredCldr);
    var properties, regionDefaultScript;
    try {
      regionDefaultScript = cldr.get(["supplemental", COMMON_ADDRESS_DATA + "AddressData", addressRegion, "primaryScript"]);
      properties = {
        maxLength: cldr.get(["supplemental", addressData, addressRegion, "maxLength"]),
        required: cldr.get(["supplemental", addressData, addressRegion, "required"]),
        validationRegex: cldr.get(["supplemental", addressData, addressRegion, "validationRegex"]),
        requiredAlgebra: cldr.get(["supplemental", addressData, addressRegion, "requiredAlgebra"]),
        addressValidations: cldr.get(["supplemental", "addressValidations"])
      };
    } finally {
      cldr.off("get", validateRequiredCldr);
    }
    var internationalRegionName;
    if (style.slice(0, 14) === "international-") {
      style = style.split("-")[1];
      internationalRegionName = cldr.get(["supplemental", addressData, addressRegion, "presetValue", "countryCode"]);
    }
    var allowedValues = cldr.get(["supplemental", addressData, addressRegion, "allowedValues"]);
    var hiddenValues = cldr.get(["supplemental", addressData, addressRegion, "hidden"]);
    var disabledValues = cldr.get(["supplemental", addressData, addressRegion, "disabled"]);
    var presetValue = cldr.get(["supplemental", addressData, addressRegion, "presetValue"]);

    // Transforms "multiline" into "multi" and "singleline" into "single".
    style = style.slice(0, -4);
    var stringLayouts = shallowMerge([cldr.get(["supplemental", addressData, addressRegion, "layouts/default"]), cldr.get(["supplemental", addressData, addressRegion, "layouts", style])]);
    var transforms = cldr.get(["supplemental", addressData, addressRegion, "transforms"]);
    var supportedScripts = Object.keys(stringLayouts);
    this._validate = function (address, options) {
      options.addressRegion = addressRegion;
      options.addressData = addressData;
      return validateAddress(address, type, properties, options);
    };
    var instance;
    this.personNameFormatterSingleton = function () {
      if (instance) {
        return instance;
      } else {
        instance = new NameFormat(worldReady, {
          nameRegion: addressRegion
        });
        return instance;
      }
    };
    this._formatToParts = function (address, options) {
      return addressFormatToParts.call(_this2, address, options, {}, {
        allowedValues: allowedValues,
        internationalRegionName: internationalRegionName,
        regionDefaultScript: regionDefaultScript,
        localeScript: localeScript,
        stringLayouts: stringLayouts,
        supportedScripts: supportedScripts,
        transforms: transforms,
        type: type,
        requiredValues: properties.required,
        hiddenValues: hiddenValues,
        disabledValues: disabledValues,
        presetValue: presetValue,
        language: worldReady.language
      });
    };

    // Clone + delete required method so we can look it up from runtime cache correctly based on options
    options.addressData = addressData;
    var _options7 = options,
      requiredMethod = _options7.requiredMethod;
    var _runtimeOptions = {};
    objectDeepAssign(_runtimeOptions, options);
    delete _runtimeOptions.requiredMethod;
    this._runtimeArgs = [_runtimeOptions];
    if (requiredMethod === "validateAddress") {
      this._runtimeValue = {
        properties: properties,
        type: type,
        options: options,
        requiredMethod: requiredMethod
      };
    } else if (requiredMethod === "addressFormatToParts") {
      this._runtimeValue = {
        allowedValues: allowedValues,
        internationalRegionName: internationalRegionName,
        regionDefaultScript: regionDefaultScript,
        localeScript: localeScript,
        stringLayouts: stringLayouts,
        supportedScripts: supportedScripts,
        transforms: transforms,
        type: type,
        requiredValues: properties.required,
        hiddenValues: hiddenValues,
        disabledValues: disabledValues,
        requiredMethod: requiredMethod,
        language: worldReady.language
      };
    }
  }
  var _proto = AddressFormat.prototype;
  _proto.format = function format(address, options) {
    return this.formatToParts(address, options).filter(function (_ref24) {
      var value = _ref24.value;
      return value;
    }).map(function (_ref25) {
      var value = _ref25.value;
      return value;
    }).join("\n");
  };
  _proto.formatToParts = function formatToParts(address, options) {
    if (process.env.NODE_ENV !== ENVIRONMENT.PRODUCTION) {
      addressFormatToPartsAsserts.call(this, address);
    }
    return this._formatToParts(address, options || {});
  };
  _proto.validate = function validate(address, options) {
    if (options === void 0) {
      options = {};
    }
    options.addressType = options.addressType || ADDRESS_TYPES_FOR_PO_BOX_RURAL_ROUTE_VALIDATION.SHIPPING;
    if (process.env.NODE_ENV !== ENVIRONMENT.PRODUCTION) {
      assertAddress$1(address, this.type, this.addressRegion);
      assertType(options, "options", ["plain object"]);
      assertType(options.addressType, "options.addressType", ["string"]);
      assertRange(options.addressType, Object.values(ADDRESS_TYPES_FOR_PO_BOX_RURAL_ROUTE_VALIDATION), "Invalid options.addressType {{value}}, expected one of {{addressTypes}}", {
        value: options.addressType,
        addressTypes: Object.values(ADDRESS_TYPES_FOR_PO_BOX_RURAL_ROUTE_VALIDATION)
      });
    }
    return this._validate(address, Object.assign({}, options));
  };
  return AddressFormat;
}();
var AddressConverter = /*#__PURE__*/function () {
  function AddressConverter(options) {
    options.from = options.from || options.fromType;
    options.to = options.to || options.toType;
    if (process.env.NODE_ENV !== ENVIRONMENT.PRODUCTION) {
      assertType(options, "options", ["undefined", "plain object"]);
      assertType(options.from, "options.from", ["string"]);
      assertType(options.to, "options.to", ["string"]);
      var validFromTypes = Object.values(ADDRESS_TRANSFORM_TYPES);
      var validToTypes = [ADDRESS_TRANSFORM_TYPES.COARSE, ADDRESS_TRANSFORM_TYPES.PORTABLE];
      assertRange(options.from, validFromTypes, "Invalid options.from {{value}}, expected one of {{validFromTypes}}.", {
        value: options.from,
        validFromTypes: validFromTypes
      });
      assertRange(options.to, validToTypes, "Invalid options.to {{value}}, expected one of {{validToTypes}}.", {
        value: options.to,
        validToTypes: validToTypes
      });
    }
    var cldr = new Cldr("und");
    this.options = options;

    // Not taking too much care about using minimal data here with the
    // assumption this is used in server-side.
    cldr.on("get", validateRequiredCldr);
    var addressData = null;
    try {
      addressData = cldr.get("supplemental/portableAddressData");
    } finally {
      cldr.off("get", validateRequiredCldr);
    }
    this._transform = Object.assign.apply(Object, Object.keys(addressData).map(function (addressRegion) {
      var _addressMetadata, _ref26;
      var addressMetadata = (_addressMetadata = {}, _addressMetadata[addressRegion] = addressData[addressRegion], _addressMetadata.addressRegion = addressRegion, _addressMetadata);
      return _ref26 = {}, _ref26[addressRegion] = function (address) {
        return transformAddress$1(address, options, addressMetadata);
      }, _ref26;
    }));
  }
  var _proto2 = AddressConverter.prototype;
  _proto2.transform = function transform(address) {
    if (process.env.NODE_ENV !== ENVIRONMENT.PRODUCTION) {
      assertType(address, "address", ["plain object"]);
    }
    address = address || {};
    var originalCountryCode = address.countryCode || address.country;
    address.countryCode = getResolvedRegion(originalCountryCode);
    if (process.env.NODE_ENV !== ENVIRONMENT.PRODUCTION) {
      assertType(address.countryCode, "address.countryCode", ["string"]);
    }
    if (process.env.NODE_ENV !== ENVIRONMENT.PRODUCTION) {
      var availableRegions = Object.keys(this._transform);
      assertRange(address.countryCode, availableRegions, "Invalid address.countryCode value {{value}}, expected one of {{availableRegions}}}", {
        value: address.countryCode,
        availableRegions: availableRegions
      });
    } else {
      // TODO standardize error handling in production
      if (!this._transform[address.countryCode]) {
        console.error(new Error("Invalid address.countryCode range").stack);
        return address;
      }
    }
    var transformedAddress = this._transform[address.countryCode](address);
    if (transformedAddress.countryCode) {
      transformedAddress.countryCode = originalCountryCode;
    }
    return transformedAddress;
  };
  return AddressConverter;
}();
var AddressUtility = {
  /**
   * Utility function to convert keys of an object that are in snake case to camel case.
   *  NOTE: This function doesn't update the values of an object.
   * @param {Object} address an object whose keys needs to be converted to camel case
   * @returns {Object} an object whose keys have been converted to camel case
   */
  camelizeAddress: function camelizeAddress(address) {
    return camelizeObject(address);
  },
  /**
   * Utility function to convert keys of an object from camel case to snake case
   *  NOTE: This function doesn't update the values of an object.
   * @param {Object} address an object whose keys needs to be converted to snake case
   * @returns {Object} an object whose keys have been converted to snake case
   */
  snakeCaseAddress: function snakeCaseAddress(address) {
    return snakeCaseObject(address, {
      line1: "line1",
      line2: "line2"
    });
  }
};
if (process.env.NODE_ENV !== ENVIRONMENT.PRODUCTION) {
  assertAddress$1 = function assertAddress$1(address, type, addressRegion) {
    assertType(address, "address", ["plain object"]);
    if (address.country_code || address.address_line_1) {
      throw new Error("DEPRECATED WARNING: AddressFormat API has changed for consistency with other formatters. Now, we expect address obejct using camelCase keys. Sorry for the inconvenience, but we decided to do this change sooner than later since WorldReady is all about consistency.\nFix your address object by using:\n" + JSON.stringify(camelizeObject(address), null, 2) + "\nWe also provide a utility you can use to transform your models:\nAddressUtility.camelizeAddress(address);");
    }
    elements[type].forEach(function (element) {
      assertType(objectGet(address, element), "address." + element, ["string", "undefined"]);
    });
    address.countryCode = getResolvedRegion(address.countryCode);
    if (address.countryCode) {
      assertRange(address.countryCode, [addressRegion], "You created this AddressFormat using {{addressRegionObj}}, but passed an address with {{countryCodeObj}}. Please use `new AddressFormat({{expectedAddressRegionObj}})` instead.", {
        addressRegion: addressRegion,
        addressRegionObj: {
          addressRegion: addressRegion
        },
        countryCode: address.countryCode,
        countryCodeObj: {
          countryCode: address.countryCode
        },
        expectedAddressRegionObj: {
          addressRegion: address.countryCode
        }
      });
    }
  };
  addressFormatToPartsAsserts = function addressFormatToPartsAsserts(address) {
    assertAddress$1(address, this.type, this.addressRegion);
    var currUsage = "new AddressFormat(worldReady, " + JSON.stringify(this._debug_options) + ")";
    if (this.type === ADDRESS_TYPES.PORTABLE) {
      assert(!address.line1, "You are trying to format a coarse address {{address}} using `{currUsage}`. Please, use `{newUsage}` instead", {
        address: address,
        currUsage: currUsage,
        newUsage: "new AddressFormat(worldReady, " + JSON.stringify(Object.assign({}, this._debug_options, {
          type: ADDRESS_TYPES.COARSE
        })) + ")"
      });
    }
    if (this.type === ADDRESS_TYPES.COARSE) {
      assert(!address.addressLine1, "You are trying to format a portable address {{address}} using `{currUsage}`. Please, use `{newUsage}` instead", {
        address: address,
        currUsage: currUsage,
        newUsage: "new AddressFormat(worldReady, " + JSON.stringify(Object.assign({}, this._debug_options, {
          type: ADDRESS_TYPES.PORTABLE
        })) + ")"
      });
    }
    var addressRegion = this.type === ADDRESS_TYPES.PORTABLE ? address.countryCode : address.countryCode || address.country;
    if (addressRegion) {
      assert(addressRegion === this.addressRegion, "You are trying to format a {{addressRegion}} address (see {{value}}) using `{currUsage}`. Please, use `{newUsage}` instead", {
        addressRegion: addressRegion,
        value: {
          countryCode: addressRegion
        },
        currUsage: currUsage,
        newUsage: "new AddressFormat(worldReady, " + JSON.stringify(Object.assign({}, this._debug_options, {
          addressRegion: addressRegion
        })) + ")"
      });
    }
  };
}

export { AddressConverter, AddressFormat, AddressUtility };
